export function isArray(value: unknown): value is unknown[] {
  return Array.isArray(value);
}

export function isNil(value: unknown): value is null | undefined {
  return value == null;
}

export function isFunction(f: unknown): boolean {
  return typeof f === 'function';
}

export function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function isString(value: unknown): value is string {
  return typeof value === 'string';
}

export function isBoolean(value: unknown): value is boolean {
  return typeof value === 'boolean';
}

export function isDate(value: unknown): value is Date {
  return value instanceof Date;
}

export function isNull(value: unknown): value is null {
  return value === null;
}

export function isUndefined(value: unknown): value is undefined {
  return value === undefined;
}

export function isEmpty(value: unknown): boolean {
  if (value == null) return true;
  if (isArray(value) || isString(value)) return value.length === 0;
  if (isObject(value)) return Object.keys(value).length === 0;
  return false;
}

export function isNotBlank(value: any): boolean {
  if (isNil(value)) return false;
  if (isString(value)) return value.trim().length > 0;
  return true;
}

export function capitalize(value: string): string {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export const noop = () => {};

export const removeEmptyValues = (
  obj: Record<string, unknown>,
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(obj).filter(([, value]) => {
      if (value === null || value === undefined || value === '') {
        return false;
      }

      if (Array.isArray(value) && value.length === 0) {
        return false;
      }

      return true;
    }),
  );

export const renameKeys = (
  obj: Record<string, unknown>,
  keyMap: Record<string, string>,
): Record<string, unknown> => {
  const newObj: Record<string, unknown> = {};
  Object.keys(obj).forEach((key) => {
    const nextKey = keyMap[key] || key;
    newObj[nextKey] = obj[key];
  });
  return newObj;
};
